export const MANAGER_APPROVAL_LETTER_MANUAL_SIGN_TEXT = {
  sectionStep: '05',
  sectionTitle: 'Лист-погодження',
  sectionDescription:
    'Перегляньте сформований лист-погодження, скачайте його для ручного підпису та завантажте підписаний документ.',
  uploadStep: '05.1',
  uploadTitle: 'Підписаний лист-погодження',
  uploadDescription: '',
  documentColumnLabel: 'Документ',
  actionsColumnLabel: 'Дії',
  emptyDocumentName: 'Файл не додано',
  addDocumentButton: 'Додати документ',
  openButton: 'Відкрити PDF в новій вкладці',
  previewTitle: 'Лист-погодження',
  missingFileMessage: 'Файл не завантажено.',
} as const;

export const MANAGER_APPROVAL_LETTER_CLIENT_SIGNED_TEXT = {
  sectionStep: '05',
  sectionTitle: 'Лист-погодження',
  sectionDescription: 'Перегляньте лист-погодження, підписаний клієнтом.',
  openButton: 'Відкрити PDF в новій вкладці',
  previewTitle: 'Підписаний клієнтом лист-погодження',
  missingFileMessage: 'Не вдалося знайти підписаний клієнтом лист-погодження.',
} as const;

export const MANAGER_APPROVAL_LETTER_MANUAL_SIGN_LOADING_TEXT =
  'Завантажуємо документ...';
export const MANAGER_APPROVAL_LETTER_MANUAL_SIGN_MISSING_PDF_TEXT =
  'Не вдалося завантажити PDF документ';
export const MANAGER_APPROVAL_LETTER_MANUAL_SIGN_ACCESS_DENIED_TEXT =
  'У вас немає прав доступу до ручного підпису листа-погодження AM.';

export const MANAGER_APPROVAL_LETTER_MANUAL_SIGN_GET_STARTED_PATH =
  '/guarantees/administrator/get-started';
export const MANAGER_APPROVAL_LETTER_MANUAL_SIGN_TASKS_PATH = '/tasks';
export const MANAGER_APPROVAL_LETTER_MANUAL_SIGN_FALLBACK_FILE_NAME =
  'letter_of_approval_manual_signed';
